package app.bloomey.web.modules.auth

import app.bloomey.web.core.data.SessionManager
import app.bloomey.web.core.data.UiState
import app.bloomey.web.utils.ApiError
import kotlinx.coroutines.flow.flow

class AuthRepository {
    private val apiService = AuthApi()
    fun login(email: String, password: String) = flow<UiState<Boolean>> {
        try {
            emit(UiState.Loading)
            val response = apiService.login(email, password)
            SessionManager.startSession(token = response.data.token)
            emit(UiState.Success(true))
        } catch (e: Throwable) {
            emit(UiState.Error(errorMessage = ApiError.parseMessage(e, "Unable to login")))
        }
    }
}